import React,{useContext} from "react";
import { useNavigate } from "react-router-dom";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import { UiAccordian } from "../../_uiComponents/common/form/UiToggleArea";
import LookUpTableFilterForm from "./forms/LookupTableFilterForm";
import { SearchBarWr } from "../../_uiComponents/common/form/UiInputComponents";
import LookupTableManagement from "./views/LookupTableManagement";
import { contextApiActions } from "../../../_redux/_constants";
import { Context } from "../../../_context/Store";
import CreateByFileImport from "./views/CreateByFileImport";

export default function LookupTableWrapper() {
     const navigate = useNavigate();
     const [state, dispatch] = useContext(Context);

     const createByFileImport = () => {
          dispatch({
               type: contextApiActions.UI_LARGE_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Create By File Import",
                    children: <CreateByFileImport/>,
               },
          });
     };

     return (
          <>
               <MainLeftTitle title="Lookup Table Management">
                    <div className="sb-lookup-table-create-btn">
                         <CreateButton
                              name="Create"
                              onClick={() => navigate("/app/lookup-data-manage/add")}
                         />
                    </div>
                    <div className="sb-lookup-table-create-btn">
                         <CreateButton
                              name="Create By File Import"
                              onClick={createByFileImport}                         
                         />
                    </div>
               </MainLeftTitle>
               
               <LookupTableManagement />
          </>
     );
}
